import ARROW_LEFT from 'assets/images/arrow_left_gray.png'
import LOGO from 'assets/images/codelovers_logo.jpg'
import POWERED_BY from 'assets/images/powered_by_family_biz.png'
import WEBSITE_IMAGE from 'assets/images/website_image.png'
import REGISTER_STEP_1 from 'assets/images/register_step1.svg'
import REGISTER_STEP_2 from 'assets/images/register_step2.svg'
import REGISTER_STEP_3 from 'assets/images/register_step3.svg'
import REGISTER_STEP_4 from 'assets/images/register_step4.svg'
import REGISTER_SUCCESS from 'assets/images/register_success.svg'
import HAMBURGER from 'assets/images/hamburger.png'

const Images = {
    ARROW_LEFT,
    LOGO,
    POWERED_BY,
    WEBSITE_IMAGE,
    REGISTER_STEP_1,
    REGISTER_STEP_2,
    REGISTER_STEP_3,
    REGISTER_STEP_4,
    REGISTER_SUCCESS,
    HAMBURGER,
}
export default Images
